export function mapContentTypeToTypeCode(
  contentType: string | undefined,
): string {
  const ct = (contentType ?? "").toLowerCase();
  if (ct.startsWith("image/")) return "IMAGE";
  if (ct.startsWith("video/")) return "VIDEO";
  if (ct.startsWith("audio/")) return "AUDIO";
  if (ct === "application/pdf") return "PDF";
  return "DOCUMENT";
}

export function formatDateYYYYMMDD(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const yyyy = d.getFullYear().toString().padStart(4, "0");
  const mm = (d.getMonth() + 1).toString().padStart(2, "0");
  const dd = d.getDate().toString().padStart(2, "0");
  return `${yyyy}${mm}${dd}`;
}

export function buildDefaultTitle(fileItem: {
  type?: string;
  submission_survey_class?: string | null;
  submission_time_submitted?: string | null;
}): string | null {
  const surveyClass = (fileItem.submission_survey_class ?? "")
    .toString()
    .toUpperCase()
    .replace(/[\s-]+/g, "_")
    .replace(/^_+|_+$/g, "");
  const date = formatDateYYYYMMDD(fileItem.submission_time_submitted);
  if (!surveyClass || !date) return null;
  const typeCode = mapContentTypeToTypeCode(fileItem.type);
  return `${typeCode}_${surveyClass}_${date}`;
}
